<template>
    <div class="suppliers">
        <h5>Fornecedores participantes da cotação</h5>
        <table class="bordered">
            <thead>
                <tr>
                    <th>Fornecedor</th>
                    <th>Telefone</th>
                    <th>E-mail</th>
                </tr>
            </thead>
            <p v-if="hasSuppliers">Esta cotação ainda não possuí participantes.</p>
            <tbody v-else>
                <tr v-for="supplier in suppliers" :key="supplier.id">
                    <td class="name">{{ supplier.name }}</td>
                    <td class="phone">{{ supplier.phone }}</td>
                    <td class="email">{{ supplier.supplierEmail }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'Participants',
    props: {
        suppliers: {
            type: Array
        }
    },
    computed: {
        hasSuppliers() {
            return !this.suppliers.length
        }
    }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
    .suppliers {
        width: 100%;
        overflow-x: auto;
    }
    .name, 
    .phone {
       min-width: 120px;
    }
}
</style>
